export default class ContentSourceMaintenanceWindowService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('me/contentSourceMaintenanceWindows', params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('me/contentSourceMaintenanceWindows/'+id, params)
	}

	updateEntity(id, params){
		return this.apiService.callPut('me/contentSourceMaintenanceWindows/'+id, params);
	}

	createEntity(params){
		return this.apiService.callPost('me/contentSourceMaintenanceWindows', params);
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('me/contentSourceMaintenanceWindows/' + id, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/ContentSourceMaintenaceWindowService.js